import { PLBillDetailsData, PL_WIDGET_TYPES, ReviewedCartApiResponse } from "@swiggy-private/cart-types";

export const getPLBillDetails = (data?: ReviewedCartApiResponse | null): PLBillDetailsData | undefined =>
    data?.cards?.find((card) => card["widget-type"] === PL_WIDGET_TYPES.BILL_DETAILS)?.details;
